export default "/images/c1d5dfd85e2ff55ed011e0bd885bfb65.avif";